import Phaser, {
    Display
} from 'phaser'
import gsap from "gsap";




let parent;
let gameScale;
let img;
let world;
let isLocation;
let imgClone;
let utils;
let padding;
let topPadding;
//let isLandscape;
let w;
let h;
let xmlLoader;
let next;
let back;
let imgScale;
let bgImg;

export default class OverlayGraphics extends Phaser.Scene {
    constructor() {
        super('overlayGraphics')
    }
    init(data) {
        imgScale = 1;
        parent = data.parent;
        img = data.img;
        isLocation = data.isLocation;
        xmlLoader = data.xmlLoader;

    }
    preload() {

    }
    create() {

        parent.setOverlayGraphics(this);
        parent.events.on('shutdown', this.stopped, this);
        gameScale = this.registry.get('scaleIt');
        world = this.scene.get('world');
        utils = this.scene.get('utils');
        padding = this.registry.get('padding');
        topPadding = 105 * gameScale;
        w = this.game.canvas.width;
        h = this.game.canvas.height



        this.createButtons();

        this.createImage();
        this.createClose();
        /*if (!isLocation) {
        }
*/
        if (xmlLoader.getAttribute('special', xmlLoader.getSection()) == 'image') {
            this.createSectionImage();
        }
    }

    createSectionImage() {
        let section = xmlLoader.getSection();
        let id = xmlLoader.getAttribute('id', section);
        let imgX = xmlLoader.getAttribute('x', section);
        let imgY = xmlLoader.getAttribute('y', section);
        let img = utils.addImage(parent, {
            x: imgX,
            y: imgY,
            id: id
        });

        //img.alpha = 1;
        img.setDepth(-100);

        //parent.sendToBack(img);

    }

    stopped() {
        this.scene.stop('overlayGraphics');
    }
    setImage(data) {
        if (imgClone) imgClone.destroy();
        imgClone = utils.addImage(parent, {
            x: data.x || 0,
            y: data.y || 0,
            id: data.id
        })
    }

    createImage() {
        //place a copy of the image that was clicked from the world scene
        let imgX;
        let imgY;
        let id = img.getData('swapImage');


        if (!isLocation) {
            //coming from inside a location, xy starts at 0,0

            imgX = img.x - img.displayWidth / 2;
            imgY = img.y - img.displayHeight / 2;
        } else {
            //The original image is coming from the world scene so calculate the x/y
            imgX = img.x - world.getScroll()[0] - img.displayWidth / 2 + this.registry.get('startX');
            imgY = img.y - world.getScroll()[1];
        }

        //Determine if we clone the existing or swap it out

        if (id) {
            let thisX = (imgX - img.width / 2) / gameScale;
            let thisY = (imgY - img.height / 2) / gameScale;
            if (thisX < 0) thisX = imgX / gameScale;
            if (thisY < 0) thisY = imgY / gameScale;

            this.setImage({
                x: thisX,
                y: thisY,
                id: id
            });


            //If the image takes up the entire background than set the x to 0
        } else {
            //Clone the image that was just clicked
            imgClone = parent.add.renderTexture(imgX, imgY, img.width, img.height);
            //put scale to 1 to take a copy at the highest resolution
            img.scale = 1;
            //draw the render of this image
            imgClone.draw(img, img.displayWidth / 2, img.displayHeight / 2);
            //put the image back to correct scale
            img.scale = imgClone.scale = img.data.get('scale');
        }
        this.animateImage();
        parent.active();
    }



    animateImage() {
        //Don't animate in the special images
        if (parent.getSpecial() === 'image') return;

        let isLandscape = parent.checkLandscape();
        imgScale = 1;
        let maxWidth = 285 * gameScale;
        let maxHeight = 180 * gameScale;
        //sie things based on max width/height
        if (isLandscape) {
            if (img.height > maxHeight) imgScale = maxHeight / img.height;
        } else {
            if (img.width > maxWidth) imgScale = maxWidth / img.width;
        }

        //Most images need spacing away from the edge
        let imgX = padding * 2;
        //But some images are used as a background
        if (imgClone.width >= this.sys.canvas.width) imgX = 0;
        //tween copy of image to new location in layout
        gsap.to(imgClone, {
            duration: 0.5,
            x: imgX,
            y: topPadding,
            scale: imgScale,
        });
    }

    createButtons() {
        let numPages = xmlLoader.getSpeechLength();

        if (numPages <= 1) return;
        back = utils.addImage(parent, {
            id: 'backEnglish',
            x: 0,
            y: 0,
            str: 'back'
        });

        utils.globalButton(back);

        next = utils.addImage(parent, {
            id: 'nextEnglish',
            x: 0,
            y: 0,
            str: 'next',

        });
        utils.globalButton(next);

        next.on('pointerup', () => {
            xmlLoader.incSpeech();
        });
        back.on('pointerup', () => {
            xmlLoader.decSpeech();
        });
        parent.disableButton(back);


    }


    createClose() {
        let close;
        close = utils.addImage(parent, {
            id: 'closeEnglish',
            str: 'close'
        });

        utils.globalButton(close);
        let menu = this.scene.get('menu');
        let menuGraphic = menu.getBGPos();
        close.x = w - close.width / 2 - 10 * gameScale;
        close.y = menuGraphic.y + menuGraphic.height + 10 * gameScale + close.height / 2;
        let navigate = this.scene.get('navigate');
        close.on('pointerup', navigate.closeIt, parent);
    }


    getBack() {
        return (back);
    }
    getNext() {
        return (next);
    }
    getImage() {
        return (imgClone);
    }
    getImageScale() {
        return (imgScale);
    }
}